import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { ProductoService } from '../../_services/producto.service';
import { forkJoin, Observable } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { SegmentoEmpleado } from '../../_models/segmento-empleado';
import { SegmentoEmpleadoService } from '../../_services/segmento-empleado.service';

@Component( {
  templateUrl: 'segmento-empleados.component.html',
  selector: 'app-segmento-empleados',
  providers: [ ConfirmationService ]
} )
export class SegmentoEmpleadosComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoEmpleados: SegmentoEmpleado[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  submitted: boolean;
  guardando: boolean;
  listaNumeroEmpleados: SelectItem[];
  allNumeroEmpleados: ListaItem[];

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoEmpleadoService: SegmentoEmpleadoService,
               private productosService: ProductoService,
               private listaService: ListaService,
               private confirmacionServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idNumeroEmpleado: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.columnas = [
      { field: 'nombreNivelEndeudamiento', header: this.navServicio.buscarMensaje( 'SEGMENTOSEMPLEADOS.LBL_NUMEROEMPLEADOS' ), sort: true }
    ];
    if ( !this.detalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }
    forkJoin( this.listaService.getMasterDetailsByOrden( 'ListasNumerosEmpleados' ),
      this.segmentoEmpleadoService.obtenerPorSegmento( this.segmento.idSegmento ) ).subscribe( ( [ res1, res2 ] ) => {
      this.allNumeroEmpleados = res1;
      this.segmentoEmpleados = res2;
      this.carDropdown();
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }

  carDropdown(): void {
    this.listaNumeroEmpleados = [];
    this.allNumeroEmpleados.map( p => {
      if ( p.indicadorHabilitado && !this.segmentoEmpleados.find( sp => sp.indicadorHabilitado && sp.idNumeroEmpleado === p.idLista ) ) {
        this.listaNumeroEmpleados.push( { label: p.nombre, value: p.idLista } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get segEmpleados() {
    return this.segmentoEmpleados.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carSegmentoProducto = true;
      const temp: SegmentoEmpleado = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      temp.nombreNumeroEmpleado = this.allNumeroEmpleados.find( p => p.idLista === temp.idNumeroEmpleado ).nombre;
      const a = this.segmentoEmpleados.find( sp => sp.idSegmentoEmplado === temp.idSegmentoEmplado );
      if ( a ) {
        temp.idSegmentoEmplado = a.idSegmentoEmplado;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoEmplado ) {
        this.segmentoEmpleadoService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoEmpleado[] = this.segmentoEmpleados;
          this.segmentoEmpleados = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoEmplado === temp.idSegmentoEmplado ) {
              t.indicadorHabilitado = true;
            }
          } );
          this.segmentoEmpleados = tempSegmentoP;
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 2 );
        } );
      } else {
        this.segmentoEmpleadoService.agregar( temp ).subscribe( res => {
          temp.idSegmentoEmplado = res.idSegmentoEmplado;
          this.segmentoEmpleados.push( temp );
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 1 );
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoEmpleado ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Empleados',
      icon: 'fa fa-question-circle',
      key: 'empleados',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoEmpleadoService.actualizar( row ).subscribe( res => {
          const temp: SegmentoEmpleado[] = this.segmentoEmpleados;
          this.segmentoEmpleados = [];
          temp.map( t => {
            if ( t.idSegmentoEmplado === row.idSegmentoEmplado ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoEmpleados = temp;
          this.carDropdown();
        } );
      }
    } );
  }
}
